import React from 'react';
import styled from 'styled-components';

const SpacerWrapper = styled.div`
  height: ${({ size, theme }) =>
    size ? theme.spacers[size] : theme.spacers.m};
`;

export const Spacer = ({ size }) => <SpacerWrapper size={size} />;
